export { Media as default } from './Media';